import React from "react";
import Input from "../common/Input";

function SCFRCPS({ data, handleChange, handleSave }) {
  return (
    <>
      <Input
        name="dssId"
        label="DSS Identifier"
        value={data.DynamicFields.results.dssId}
        onChange={handleChange}
      />
      <Input
        name="reason"
        label="Reason for Referral"
        value={data.DynamicFields.results.reason}
        onChange={handleChange}
      />
      <Input
        name="assignedFRS"
        label="Assigned Family Resource Specialist (FRS)"
        value={data.DynamicFields.results.assignedFRS}
        onChange={handleChange}
      />
      <Input
        name="initialContact"
        label="Initial Contact Due On"
        value={data.DynamicFields.results.initialContact}
        onChange={handleChange}
      />

      <button className="btn btn-primary ms-2" onClick={() => handleSave()}>
        Save Referral
      </button>
    </>
  );
}

export default SCFRCPS;
